import { fieldSuggestions as HeadlessFieldSuggestions } from "./search-box/controllers/field-suggestion-controller";

import { searchBox as SearchBoxController } from "./search-box/controllers/search-box-controller";
import { DrhSearchBox } from "./search-box/components/drh-search-box";

function App() {
	const isHomepage = window.location.pathname === "/";

	const formClassName = isHomepage ? "search-frame" : "search-frame top-search";

	return (
		<div className={formClassName}>
			<DrhSearchBox
				searchBoxController={SearchBoxController}
				fieldSuggestController={HeadlessFieldSuggestions}
				isHomepage={isHomepage}
			/>
		</div>
	);
}

export default App;
